import React, { useEffect, useState } from 'react';
import Loader from '../../../common/Loader';
import { useFetchCheckbetTicket } from '../../../data/fetchCheckbetTicket';
import { getLabel } from '../../../InitData';
import BetInfo from './BetInfo';
import EventsList from './EventsList';


function SingleBetTicket(props) {

    const [data, setData] = useState(null);
    const [state] = useFetchCheckbetTicket(props.ticket.id, true, props.ticket.isLive);

    useEffect(() => {
        if (props.index && !props.toggled) {
            props.toggleTicket(props.ticket.id);
        }
    }, []);

    useEffect(() => {
        if (state.data != null && !state.isError) {
            setData(state.data);
        }
    }, [state.data, state.isError]);

    if (state.isLoading) {
        return <Loader />;
    } else if (data == null) {
        return <Loader error={true} />;
    }

    function toggleMatches() {
        props.toggleTicket(props.ticket.id);
    }

    const getEsitoClass = function (eventStatus, winning, winningDrawCode) {
        if (eventStatus === 'voided') {
            return 'esito-vd';
        }
        if (!['winning', 'losing'].includes(eventStatus) || !winningDrawCode) {
            return 'esito-nd';
        }
        return winning ? 'esito-v' : 'esito-p';
    }

    return (
        <div className="mybet-container d-flex flex-column | mb_5">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle | mb_5_1" onClick={toggleMatches}>
                <span className="text-big bold | mb_5_1_1">{getLabel('mybets.singola')}</span>
                <span className="margine-sx margin-right-auto | mb_5_1_2">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_3">{getLabel('mybets.freebet')}</span>
                    }
                    {props.ticket.isBetBuilder &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_3">{getLabel('betbuilder.title')}</span>
                    }
                </span>
                <span className="visibility-hidden | mb_5_1_4">{getLabel('mybets.singola')}</span>
                <span className="mb_5_1_3" onClick={toggleMatches}>
                    <i className={`mb_5_1_3__${props.toggled ? 'less' : 'more'}`}></i>
                </span>
            </div>
            <div className='mybet-container__event-list__wrapper'>
                {state.data == null ?
                    <Loader error={state.isError} />
                    :
                    state.data.events.map((event, i) => {
                        return event.bets.map((bet, i) => {
                            return <div key={i} className="event-list__outcome-symbol">
                                <span className={"esito | mb_10_3_2_1_3 " + getEsitoClass(bet.state, bet.isWinning, bet.winningDrawCode)}></span>
                            </div>
                        })
                    }
                    )}
            </div>
            <hr className="mb_4" />
            {props.toggled &&
                <div className="mybet-events-container | mb_6">
                    <EventsList events={data.events} isBetBuilder={data.betBuilder} isCheckbet={false} />
                </div>
            }
            <div className="light-grey-bg | mb_5_3">
                <BetInfo ticket={props.ticket} isCheckbet={false} />
            </div>
        </div>
    );
}

export default SingleBetTicket;